import Vue from 'vue'

// Language files
import en from './lang/en.json'
import es from './lang/es.json'
import it from './lang/it.json'

// IE11 polyfill
require('@babel/polyfill')

// Bootstrap
require('./bootstrap')

// Vue
window.Vue = require('vue')
var has = require('lodash.has')

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// eslint-disable-next-line
Vue.mixin({
  computed: {
    my360FormOld () {
      if (window.my360FormData) {
        return window.my360FormData.old
      }
      return {}
    },
    my360FormErrors () {
      if (window.my360FormData) {
        return window.my360FormData.errors
      }
      return {}
    },
    csrfToken () {
      return window.csrfToken
    }
  },
  methods: {
    __ (key, replaceArr = []) {
      var langKey = window.my360FormData.lang || 'en'
      switch (langKey) {
        case 'en':
          key = en[key]
          break
        case 'es':
          key = es[key]
          break
        case 'it':
          key = it[key]
          break
      }

      replaceArr.forEach((obj) => {
        var replaceKey = Object.keys(obj)[0]
        key = key.replace(`:${replaceKey}`, obj[replaceKey])
      })
      return key
    },
    hasKey (object, path) {
      return has(object, path)
    }
  }
})

// eslint-disable-next-line
const app = new Vue({
  el: '#app',
  data () {
    return {
      ranges: {}
    }
  }
})
